import type { FunctionComponent } from 'react'
import { DashRoute } from '../../legacy/dash-components/dash-route/DashRoute'
import { DashRedirect } from '../../legacy/dash-components/dash-redirect/DashRedirect'
import { DashSwitch } from '../../legacy/dash-components/dash-switch/DashSwitch'
import { AiAgentProvider } from '../../utils/contexts/ai/AiAgentProvider'
import { ImpersonationStatusBanner } from '../../gin-and-tonic/containers/impersonation-status-banner/ImpersonationStatusBanner'
import { PartnerWriteAccessErrorNotifier } from '../../gin-and-tonic/common/partner-write-access-error/PartnerWriteAccessErrorNotifier'
import { GlobalCookieDetection } from '../../utils/browser/GlobalCookieDetection'
import ScopeSelectionPage from './scope-selection/ScopeSelectionPage'
import { NotLoggedInRedirect } from './components/NotLoggedInRedirect'
import { PartnerScopedSection } from './partner-scoped/PartnerScopedSection'

export const LoggedInRoutes: FunctionComponent = () => (
  <NotLoggedInRedirect>
    <GlobalCookieDetection />
    <AiAgentProvider>
      <PartnerWriteAccessErrorNotifier />
      <ImpersonationStatusBanner />
      <DashSwitch>
        <DashRoute route="scope" component={ScopeSelectionPage} />
        <DashRoute route="partner-scoped" component={PartnerScopedSection} />
        {/* If the user is on the URL_BASE route, we send them to the scope selector */}
        <DashRedirect exact fromRoute="base" toRoute="scope" />
      </DashSwitch>
    </AiAgentProvider>
  </NotLoggedInRedirect>
)
